<template lang="pug">
  v-card(class="sdo-card" min-height="200px")
    router-link(:to="{ name: 'WebinarView', params: { id: webinar.id }}")
      v-img(
        :src="webinar.img ? webinar.img : require('@/assets/group-sample.jpg')"
      )
    v-card-title {{ webinar.title }}
    v-card-text {{ webinar.description | truncate }}
    // Растяжка, для одинаковый высоты карточек
    div(style="height: 100%")
    v-card-text.py-0.pl-2
      v-rating(
        :value="webinar.avg_score"
        color="primary"
        class="webinar-rating mt-4 mb-4"
        :length="5"
        readonly
      )
    v-card-actions(class="pa-4")
      v-btn(
        :to="{ name: 'WebinarView', params: { id: webinar.id }}"
        color="primary"
        rounded
        small
        depressed
      )
        v-icon(left small) mdi-video-outline
        | Просмотр
      template(v-if="$user.data.id === webinar.created_by")
        v-btn(
          :to="{ name: 'WebinarUpdate', params: { id: webinar.id }}"
          color="warning"
          rounded
          small
          depressed
        )
          v-icon(left small) mdi-pencil
          | Изменить
        v-spacer
        v-btn(
          @click="$emit('delete', webinar.id)"
          color="error"
          title="Удалить"
          rounded
          small
          depressed
          icon
        )
          v-icon mdi-delete-outline

</template>

<script>
export default {
  name: 'WebinarCard',
  props: {
    webinar: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style lang="scss" scoped>
  .sdo-card {
    height: 100%;
  }

</style>
